/**
 * Maintenance activity log — what the issue pages (`/issues`) and the cleaning
 * schedules' maintenance flags (maintenance overview, cleaning detail chat) write
 * into the sidecar's generic `activity_log` journal. The view that reads it back is
 * the shared activity log (`components/pages/activity-log/`), configured for this
 * area by `MAINTENANCE_ACTIVITY_LOG`.
 *
 * No sessions: the correlation key is the `issue_id` (issues) or the `schedule_id` (flags).
 */

/** The maintenance pages' `area` in the shared journal. */
export const MAINTENANCE_ACTIVITY_AREA = 'maintenance';

/** In workflow order: reported → worked on → done → taken back → deleted. */
export const MAINTENANCE_ACTIVITY_ACTIONS = [
  'maintenance_flag',
  'issue_create',
  'issue_assign',
  'issue_comment',
  'issue_status_change',
  'issue_update',
  'maintenance_complete',
  'issue_close',
  'issue_reopen',
  'maintenance_uncomplete',
  'maintenance_unflag',
  'issue_delete'
] as const;

export type MaintenanceActivityAction = (typeof MAINTENANCE_ACTIVITY_ACTIONS)[number];

/** Where an issue was deleted. */
export type IssueDeleteSource = 'detail' | 'list';

/** Where a maintenance flag was toggled. */
export type MaintenanceFlagSource = 'overview' | 'cleaning_detail';
